export enum ChannelCustomType {
  All = 'all',
  CustomerThread = 'customerthread',
  IssueThread = 'issuethread',
  GroupThread = 'groupthread',
  Zoai = 'zo.ai',
}

export enum OrderSubTag {
  CREATE_ORDER = 'create_order',
  MODIFY_ORDER = 'modify_order',
  CANCEL_ORDER = 'cancel_order',
  ORDER_ENQUIRY = 'order_enquiry',
  PRODUCT_ENQUIRY = 'product_enquiry',
  DELIVERY_ENQUIRY = 'delivery_enquiry',
  RETURN = 'return',
  STOCK_UPDATE = 'stock_update',
  NEGOTIATION = 'negotiation',
  DISCOUNT = 'discount',
}

export enum SupportSubTag {
  ISSUE = 'issue',
  SUPPORT_REQUEST = 'support_request',
  QUERY = 'query',
}

export enum PaymentSubTag {
  PAYMENT = 'payment',
  INVOICE = 'invoice',
  LEDGER = 'ledger',
  CREDIT_NOTE = 'credit_note',
  REFUND = 'refund',
}
